var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "box-container box-credentials d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('div', {
    staticClass: "w-auto d-flex flex-column align-items-start"
  }, [_c('p', {
    staticClass: "w-auto m-0 box-text credentials-color"
  }, [_c('b', [_vm._v("Username")]), _vm._v(" : " + _vm._s(_vm.username) + " ")]), _c('p', {
    staticClass: "w-auto m-0 box-text credentials-color"
  }, [_c('b', [_vm._v("Password")]), _vm._v(" : " + _vm._s(_vm.showPassword ? _vm.password : "*********************************") + " "), _c('i', {
    staticClass: "mdi mdi-content-copy",
    style: {
      cursor: 'pointer',
      color: _vm.copied ? 'red' : 'inherit'
    },
    attrs: {
      "title": "Click to Copy Password"
    },
    on: {
      "click": _vm.copyPassword
    }
  })]), _c('b-form-checkbox', {
    model: {
      value: _vm.showPassword,
      callback: function ($$v) {
        _vm.showPassword = $$v;
      },
      expression: "showPassword"
    }
  }, [_vm._v(" Show Password ")])], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "box-container"
  }, [_c('p', {
    staticClass: "m-0 box-text text-color"
  }, [_vm._v("To access Project Spectrum’s online courses, you must log into the Encite learning management platform. Because you are a registered Project Spectrum user, we have automatically generated your login credentials, which you see below.")]), _c('p', {
    staticClass: "m-0 box-text text-color"
  }, [_vm._v("Clicking the course link will take you to the Encite login screen. You will need to copy/paste the system-generated password and log into the learning management platform.")]), _c('p', {
    staticClass: "m-0 m-3 box-text text-color"
  }, [_vm._v("If you have issues or concerns,please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:support@projectspectrum.io"
    }
  }, [_vm._v("support@projectspectrum.io")]), _vm._v(" for assistance.")])]);

}]

export { render, staticRenderFns }